import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1021ParamStatus: 'idle',
    startProcess1021ParamError: undefined as any,
    loadUserParamsProcess1021ParamStatus: 'idle',
    loadUserParamsProcess1021ParamError: undefined as any,

    process1021ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1021Param = createAsyncThunk('process1021ParamSlice/startProcess1021Param', async ({ process1021Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1021Param/`,
        prepareData(process1021Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1021ParamStatus } = getState().process1021ParamSlice
        return startProcess1021ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess1021Param = createAsyncThunk('process1021ParamSlice/loadUserParamsProcess1021Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1021Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1021ParamStatus } = getState().process1021ParamSlice
        return loadUserParamsProcess1021ParamStatus !== 'pending'
    }
})

const Process1021ParamSlice = createSlice({
    name: 'process1021ParamSlice',
    initialState,
    reducers: {
        resetstartProcess1021Param: (state) => {
            state.job = undefined
            state.startProcess1021ParamError = undefined
        },
        resetstartProcess1021ParamError: (state) => {
            state.startProcess1021ParamError = undefined
        },
        resetloadUserParamsProcess1021Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1021ParamError = undefined
        },
        resetloadUserParamsProcess1021ParamError: (state) => {
            state.loadUserParamsProcess1021ParamError = undefined
        },
        removeFromProcess1021ParamListById: (state, action) => {
            state.process1021ParamList = state.process1021ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1021ParamListByIds: (state, action) => {
            state.process1021ParamList = state.process1021ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1021ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1021ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1021ParamList = []
            state.startProcess1021ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1021Param.pending, (state) => {
            state.startProcess1021ParamStatus = 'pending'
            state.startProcess1021ParamError = undefined
        })
        builder.addCase(startProcess1021Param.fulfilled, (state, action) => {
            state.startProcess1021ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1021Param.rejected, (state, action) => {
            state.startProcess1021ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1021ParamError = action.error.message
            } else {
                state.startProcess1021ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1021Param.pending, (state) => {
            state.loadUserParamsProcess1021ParamStatus = 'pending'
            state.loadUserParamsProcess1021ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess1021Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess1021ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1021Param.rejected, (state, action) => {
            state.loadUserParamsProcess1021ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1021ParamError = action.error.message
            } else {
                state.loadUserParamsProcess1021ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1021Param,
    resetstartProcess1021ParamError,
    resetloadUserParamsProcess1021Param,
    resetloadUserParamsProcess1021ParamError,
    removeFromProcess1021ParamListById,
    removeFromProcess1021ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1021ParamSlice.actions
export default Process1021ParamSlice.reducer
